import React from 'react';
import T from 'prop-types';

import { format } from '../../../../utils/date';

const Resource = ({ resource }) => (
  <div className="resource-item">
    <i className="hicon-plus-bold" />
    <div className="resource-info">
      <a className="resource-name" href={resource.url} target="_blank" rel="noreferrer">{resource.title}</a>
      <span className="resource-date">{`${format(resource.date, 'MMM DD, YYYY')} - ${resource.source}`}</span>
    </div>
  </div>
);

Resource.propTypes = {
  resource: T.object.isRequired,
};

const AdditionalResources = ({ resources }) => (
  <div className="resources-wrapper">
    <h2 className="h1">{resources.header_text}</h2>
    <div className="resources-list">
      {resources.resources.map(resource => (
        <Resource
          key={resource.date + resource.title}
          resource={resource}
        />
      ))}
    </div>
  </div>
);

AdditionalResources.propTypes = {
  resources: T.shape({
    header_text: T.string,
    resources: T.array,
  }).isRequired,
};

export default AdditionalResources;
